<template>
    <div class="flex flex-col justify-center items-center my-4">
        <p class="font-semibold text-lg mb-2">Select Date Range</p>

        <div class="flex items-center space-x-4">
            <!-- From Date -->
            <input 
                v-model="dateRange.start"
                type="date"
                class="border px-2 py-1 w-40 rounded focus:outline-none focus:border-indigo-300"
            />

            <span class="text-gray-500">to</span>

            <!-- To Date -->
            <input 
                v-model="dateRange.end"
                type="date"
                class="border px-2 py-1 w-40 rounded focus:outline-none focus:border-indigo-300"
            />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dateRange: {
                start: new Date().toISOString().split("T")[0], // Default to today
                end: new Date().toISOString().split("T")[0],   // Default to today
            }
        };
    }
};
</script>
